/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { TextField, Box, Checkbox, FormControlLabel } from '@material-ui/core';
import moment from 'moment';
import { groupBy } from 'lodash';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import { viewPortHeight_355 } from '../../../../SharedModules/CommonConstants/commonConstants';
import TableGridWithFeatures from '../../../../SharedModules/Table/TableGridWithFeatures';
import PaginationBox from '../../../../SharedModules/PaginationBox/PaginationBox';
import {
  getndchistorydisputecode,
  getndchistorygrid,
  getndchistorygridForExportAll,
  setExportAllData,
  setLoading,
  setNDCHistoryData,
  setPaginationIndex,
} from '../Store/actions';
import Spinner from '../../../../SharedModules/Spinner/Spinner';
import { TableHead } from './TableHead';
import CustomSeparator from '../../../../SharedModules/Breadcrumbs/BreadcrumbsComponent';
import { exportAllPDF } from './exportAll';
import {
  PAGINATION_EMPTY_ERR,
  PAGINATION_NEGATIVE_ERR,
  PAGINATION_OVER_TOTAL_ERR,
} from '../../../../SharedModules/Errors/constantMessageData';
import CommonModal from '../../../../SharedModules/Dialog/CommonModal';
import DisplayErrorMessages from '../../../../SharedModules/Errors/ErrorMessages';

const DisplayNDCHistory = () => {
  const dispatch = useDispatch();

  const {
    isLoading,
    displayObj: {
      rebateProgrameName,
      searchResult = [],
      selectedNDC,
      rebateProgram,
      labelerTableData,
      rebateProgramList,
      fromQtrValue,
      toQtrValue,
      isAllQuartersValue,
      ndcHistoryDisputeCodes = [],
      countValue,
    },
    exportAllData,
    ndcHistDtlData,
  } = useSelector((state) => state?.sharedState?.NDCHistoryReducer);
  const userDefaults = useSelector(
    (state) => state?.sharedState?.UserDefaultReducer?.UserDefaultsValues?.data
  );
  const logInUser = useSelector(
    (state) => state?.sharedState?.SharedReducer?.logInUser
  );

  const [rows, setRows] = useState([]);
  const [fullScreenView, setFullScreenView] = useState(false);
  const [count, setCount] = useState(countValue);
  const [errorMessages, setErrorMessages] = React.useState([]);
  const [labelerName, setLabelerName] = useState('');
  const [exportAllClicked, setExportAllClicked] = useState(false);
  const [numOfApi, setNumOfApi] = useState(1);
  const [columnApi, setColumnApi] = React.useState(null);
  const [drugName, setDrugName] = React.useState('');
  const [ndc, setNDC] = React.useState('');
  const [labelerCode, setLablerCode] = React.useState('');

  useEffect(() => {
    setCount(countValue || 1);
  }, [countValue]);

  const [paginationArray, setPaginationArray] = useState([
    // ...Array(ndcHistDtlData?.length || []).keys(),
  ]);

  const changeFullScreenView = () => {
    setFullScreenView(!fullScreenView);
  };

  /*
    This function handle the side effect of next previios of pagination box
  */
  const handleClick = (type, value) => {
    if (type === 'next') {
      dispatch(setPaginationIndex(count + 1));
    }

    if (type === 'previous') {
      dispatch(setPaginationIndex(count - 1));
    }

    if (type === 'change') {
      if (!value) setErrorMessages([PAGINATION_EMPTY_ERR]);
      else if (value < 1) setErrorMessages([PAGINATION_NEGATIVE_ERR]);
      else if (value > paginationArray.length)
        setErrorMessages([PAGINATION_OVER_TOTAL_ERR]);
      else {
        setErrorMessages([]);
        dispatch(setPaginationIndex(value));
      }
    }
  };

  // this function handle the vlue like text in input box
  const handleBlur = (value) => {
    // if (
    //   value < 1 ||
    //   parseInt(value) > paginationArray.length ||
    //   value === '' ||
    //   isNaN(value)
    // ) {
    // dispatch(setPaginationIndex(0));
    // setTimeout(() => {
    //   value < 1
    //     ? dispatch(setPaginationIndex(1))
    //     : dispatch(setPaginationIndex(paginationArray.length));
    // }, 20);
    // }
    if (!value) setErrorMessages([PAGINATION_EMPTY_ERR]);
    else if (value < 1) setErrorMessages([PAGINATION_NEGATIVE_ERR]);
    else if (value > paginationArray.length)
      setErrorMessages([PAGINATION_OVER_TOTAL_ERR]);
    else {
      setErrorMessages([]);
      dispatch(setPaginationIndex(parseInt(value)));
    }
  };

  const disputeCodeProcess = async (tbdata = []) => {
    const allQtrs = tbdata
      .map((item) => {
        const qtr = item?.targetQtr?.split('Q') || ['', ''];
        return qtr[1] + qtr[0];
      })
      .filter((item, i, arr) => arr.indexOf(item) === i);
    const codes = await dispatch(
      getndchistorydisputecode({
        drugSeqNum: [ndcHistDtlData[count - 1]?.drugSeqNum],
        invRecSeqNum: [
          ...new Set(
            tbdata
              .filter((obj) => obj.invRecSeqNum)
              .map((obj) => obj.invRecSeqNum)
          ),
        ],
        qtr: allQtrs,
      })
    );

    // const codes = ndcHistoryDisputeCodes;

    const tempObj = {};
    for (let i = 0; i < codes.length; i += 1) {
      if (tempObj[codes[i]?.targetQtr]) {
        tempObj[codes[i]?.targetQtr].push(codes[i]);
      } else {
        tempObj[codes[i]?.targetQtr] = [codes[i]];
      }
    }
    const data = [];
    //  searchResult.map((item) => {
    //   return ;
    // });

    for (let i = 0; i < tbdata.length; i += 1) {
      const item = tbdata[i];
      data.push({
        ...item,
        changeAmt: item?.changeAmt?.toFixed(2) || '0.00',
        changeNumOfUnits: item?.changeNumOfUnits?.toFixed(4) || '0.0000',
        unitRebateAmt: item?.unitRebateAmt?.toFixed(4),
        numOfUnits: item?.numOfUnits?.toFixed(4),
        disputeCode: tempObj[item.targetQtr]
          ? tempObj[item.targetQtr].map((item) => item.disputeCd).join(',')
          : '',
      });
    }
    // if (data.length > 0) {
    setRows(data);
    // }
  };

  // On pagination change API get called from here
  React.useEffect(() => {
    // setRows([]);
    // if (selectedNDC[count - 1]) {
    //   dispatch(setNDCHistoryData([]));
    //   dispatch(
    //     getndchistorygrid({
    //       drugSeqNum: [selectedNDC[count - 1]?.drugSeqNum],
    //       rebateProgramCd: rebateProgram,
    //       startQtr: isAllQuartersValue ? '1Q1991' : fromQtrValue,
    //       toQtr: isAllQuartersValue
    //         ? `${moment(new Date()).quarter()}Q${new Date().getFullYear()}`
    //         : toQtrValue ||
    //           `${moment(new Date()).quarter()}Q${new Date().getFullYear()}`,
    //     })
    //   );
    //   const labelerName = labelerTableData.find(
    //     (item) => item.labelerCode === selectedNDC[count - 1]?.labelerCode
    //   )?.labelerName;
    //   setLabelerName(labelerName || '');
    // } else {
    //   setLabelerName('');
    // }
    if (count && ndcHistDtlData) {
      const grpData = Object.groupBy(
        searchResult,
        ({ drugSeqNum }) => drugSeqNum
      );
      const currDrugSeq = ndcHistDtlData?.[count - 1]?.drugSeqNum;
      setDrugName(ndcHistDtlData?.[count - 1]?.drugName);
      setNDC(ndcHistDtlData?.[count - 1]?.ndc);
      setLablerCode(ndcHistDtlData[count - 1]?.labelerCode);

      const labelerName = labelerTableData.find(
        (item) => item.labelerCode === ndcHistDtlData[count - 1]?.labelerCode
      )?.labelerName;
      setLabelerName(labelerName || '');
      const currTblData = grpData[currDrugSeq];
      disputeCodeProcess(currTblData);
      // setRows(grpData[currDrugSeq]);
    }
  }, [count]);

  // Result for NDC details grid set from here
  // React.useEffect(() => {
  //   const codes = ndcHistoryDisputeCodes;

  //   const tempObj = {};
  //   for (let i = 0; i < codes.length; i += 1) {
  //     if (tempObj[codes[i]?.targetQtr]) {
  //       tempObj[codes[i]?.targetQtr].push(codes[i]);
  //     } else {
  //       tempObj[codes[i]?.targetQtr] = [codes[i]];
  //     }
  //   }
  //   const data = [];
  //   //  searchResult.map((item) => {
  //   //   return ;
  //   // });

  //   for (let i = 0; i < searchResult.length; i += 1) {
  //     const item = searchResult[i];
  //     data.push({
  //       ...item,
  //       changeAmt: item?.changeAmt?.toFixed(2) || '0.00',
  //       changeNumOfUnits: item?.changeNumOfUnits?.toFixed(4) || '0.0000',
  //       unitRebateAmt: item?.unitRebateAmt?.toFixed(4),
  //       numOfUnits: item?.numOfUnits?.toFixed(4),
  //       disputeCode: tempObj[item.targetQtr]
  //         ? tempObj[item.targetQtr].map((item) => item.disputeCd).join(',')
  //         : '',
  //     });
  //   }
  //   if (data.length > 0) {
  //     setRows(data);
  //   }
  // }, [ndcHistoryDisputeCodes]);

  React.useEffect(() => {
    if (ndcHistDtlData?.length > 0) {
      // const allQtrs = searchResult
      //   .map((item) => {
      //     const qtr = item?.targetQtr?.split('Q') || ['', ''];
      //     return qtr[1] + qtr[0];
      //   })
      //   .filter((item, i, arr) => arr.indexOf(item) === i);
      // dispatch(
      //   getndchistorydisputecode({
      //     drugSeqNum: [ndcHistDtlData[count - 1]?.drugSeqNum],
      //     invRecSeqNum: ndcHistDtlData[count - 1]?.invRecSeqNum
      //       ? [ndcHistDtlData[count - 1]?.invRecSeqNum]
      //       : [],
      //     qtr: allQtrs,
      //   })
      // );
      setPaginationArray([...Array(ndcHistDtlData?.length).keys()]);
    }
  }, [ndcHistDtlData]);

  // selected rebate program short descript is calculayted from here
  const rebateProgramShortDesc = rebateProgramList.find(
    (item) => item.rebateProgramCd === rebateProgram
  )?.shortDescr;
  // const drugName = selectedNDC[count - 1]?.drugName
  //   ? selectedNDC[count - 1]?.drugName
  //   : '';
  // const ndc = selectedNDC[count - 1]?.ndc;
  // const labelerCode = selectedNDC[count - 1]?.labelerCode;
  const qtrRange = isAllQuartersValue
    ? 'All Quarters'
    : `${fromQtrValue} - ${
        toQtrValue ||
        `${moment(new Date()).quarter()}Q${new Date().getFullYear()}`
      }`;

  // Below variable are used for PDF header
  const firstInfo = `Mfg: ${labelerCode} - ${labelerName || ''}`;
  const secondInfo = `NDC: ${ndc}`;
  const thirdInfo = `${rebateProgrameName}`;
  const fourthInfo = `Quarter Range: ${qtrRange}`;
  const fifthInfo = `Drug Name: ${drugName}`;

  function divideArray(array, parts) {
    const { length } = array;
    const partSize = Math.ceil(length / parts); // Calculate the size of each part

    const dividedParts = [];
    let index = 0;

    while (index < length) {
      dividedParts.push(array.slice(index, index + partSize));
      index += partSize;
    }

    return dividedParts;
  }

  const [exportFileName, setExportFileName] = React.useState(null);
  const exportAllTpPDF = (name) => {
    setExportFileName(name);
    setExportAllClicked(true);
    const selectedAllNDC = selectedNDC.map((item) => item.drugSeqNum);
    const numOfApiCallRequired = Math.ceil(selectedAllNDC.length / 1000);
    const dividedArray = divideArray(selectedAllNDC, numOfApiCallRequired);
    setNumOfApi(numOfApiCallRequired);
    dispatch(setExportAllData([], 'noData'));
    dispatch(
      getndchistorygridForExportAll(
        {
          rebateProgramCd: rebateProgram,
          startQtr: isAllQuartersValue ? '1Q1991' : fromQtrValue,
          toQtr: isAllQuartersValue
            ? `${moment(new Date()).quarter()}Q${new Date().getFullYear()}`
            : toQtrValue ||
              `${moment(new Date()).quarter()}Q${new Date().getFullYear()}`,
        },
        dividedArray
      )
    );
  };
  const onGridReady = (params) => {
    setColumnApi(params.columnApi);
  };
  useEffect(() => {
    if (numOfApi === Object.keys(exportAllData).length) {
      dispatch(setLoading(true));
      let allData = [];
      for (const key in exportAllData) {
        allData = [...allData, ...exportAllData[key]];
      }

      allData.sort((a, b) => {
        // Primary sort
        const qtrA = a.targetQtr || '';
        const qtrB = b.targetQtr || '';
        
        const parseQtr = (qtrStr) => {
          const match = qtrStr.match(/(\d+)Q(\d+)/);
          if (match) {
            return { quarter: parseInt(match[1], 10), year: parseInt(match[2], 10) };
          }
          return { quarter: 0, year: 0 };
        };
        
        const qtrAObj = parseQtr(qtrA);
        const qtrBObj = parseQtr(qtrB);
        if (qtrAObj.year !== qtrBObj.year) {
          return qtrBObj.year - qtrAObj.year;
        }
        
        if (qtrAObj.quarter !== qtrBObj.quarter) {
          return qtrBObj.quarter - qtrAObj.quarter;
        }
        
        // Secondary sort
        const dateA = new Date(a.drugActivityDt || 0);
        const dateB = new Date(b.drugActivityDt || 0);
        return dateA.getTime() - dateB.getTime();
      });

      allData = allData.map((item) => {
        return {
          ...item,
          changeNumOfUnits: item.changeNumOfUnits?.toFixed(4) || '0.0000',
          numOfUnits: item?.numOfUnits?.toFixed(4),
          // unitRebateAmt: parseFloat((item.unitRebateAmt || 0).toFixed(2)),
          unitRebateAmt: item?.unitRebateAmt?.toFixed(4),
        };
      });
      const groupedData = groupBy(allData, 'drugSeqNum');
      const header = {
        reportName: 'NDC History Report',
        fileName: exportFileName || 'NDC History Report',
      };

      const mapping = {};
      const labelerMapping = {};
      for (let i = 0; i < labelerTableData.length; i += 1) {
        labelerMapping[labelerTableData[i].labelerCode] =
          labelerTableData[i].labelerName;
      }
      for (let i = 0; i < selectedNDC.length; i += 1) {
        mapping[selectedNDC[i].drugSeqNum] = {
          ...selectedNDC[i],
          labelerName: labelerMapping[selectedNDC[i].labelerCode],
        };
      }
      const options = {
        info: { thirdInfo, fourthInfo },
        titleName: 'Drug Seq Num: ',
        mapping,
      };
      const paginationArr = [];
      const widths = [];
      if (exportAllClicked) {
        setExportAllClicked(false);
        exportAllPDF(
          header,
          groupedData,
          columnApi,
          userDefaults,
          options,
          paginationArr,
          widths,
          logInUser
        );
      }
      dispatch(setLoading(false));
    }
  }, [exportAllData]);
  let applyingSortPatch = false;
  const onSortChanged  = (params)=>{

 if (applyingSortPatch) return;

  const state = params.columnApi.getColumnState();
  const qtr = state.find(s => s.colId === 'targetQtr');
  const dt  = state.find(s => s.colId === 'drugActivityDt');

  // Only enforce when Quarter is currently sorted
  if (qtr && qtr.sort) {
    const desired = [
      { colId: 'targetQtr',    sort: qtr.sort, sortIndex: 0 },
      { colId: 'drugActivityDt', sort: 'asc',   sortIndex: 1 },
    ];

    // Check if already in desired state (avoid loops)
    const alreadyOk =
      qtr.sortIndex === 0 &&
      dt?.sort === 'asc' &&
      dt?.sortIndex === 1;

    if (!alreadyOk) {
      applyingSortPatch = true;
      params.columnApi.applyColumnState({
        state: desired,
        defaultState: { sort: null },
      });
      applyingSortPatch = false;
    }
  }

  }
  return (
    <div className="tabs-container">
      <CustomSeparator parent1="Detail Reports" parent2="Display NDC History" />
      <Spinner load={isLoading} />
      <DisplayErrorMessages errorMessages={errorMessages} />
      <div className="tab-body">
        {!fullScreenView && (
          <>
            <div className="row">
              <div className="col-12  ">
                <div className="form-wrapper p-0 mt-2">
                  <div className="mui-custom-form input-md field-xl">
                    <div className="row mb-5">
                      <div className="col-12">
                        <div className="float-right">
                          <PaginationBox
                            data-testid="req-NDC-history-blur"
                            array={paginationArray}
                            count={count}
                            handleClick={handleClick}
                            handleBlur={handleBlur}
                          />
                        </div>
                      </div>
                    </div>
                    <div className="row mb-2">
                      <div className="col-6">
                        <TextField
                          label="Rebate Program: "
                          id="Rebate Program"
                          fullWidth
                          placeholder=""
                          InputLabelProps={{
                            shrink: true,
                          }}
                          disabled
                          value={rebateProgrameName}
                        />
                      </div>
                      <div className="col-6">
                        <TextField
                          label="NDC: "
                          id="NDC"
                          fullWidth
                          placeholder=""
                          InputLabelProps={{
                            shrink: true,
                          }}
                          disabled
                          value={ndc}
                        />
                      </div>
                    </div>
                    <div className="row mb-2">
                      <div className="col-6">
                        <TextField
                          label="Manufacturer Id: "
                          id="Manufacturer Id"
                          fullWidth
                          placeholder=""
                          InputLabelProps={{
                            shrink: true,
                          }}
                          disabled
                          value={labelerCode}
                        />
                      </div>
                      <div className="col-6">
                        <TextField
                          label="Name: "
                          id="Name"
                          fullWidth
                          placeholder=""
                          InputLabelProps={{
                            shrink: true,
                          }}
                          disabled
                          value={labelerName}
                        />
                      </div>
                    </div>
                    <div className="row mb-2">
                      <div className="col-6">
                        <TextField
                          label="Drug Name: "
                          id="Drug Name"
                          fullWidth
                          placeholder=""
                          InputLabelProps={{
                            shrink: true,
                          }}
                          disabled
                          value={drugName}
                        />
                      </div>

                      <div className="col-6">
                        <TextField
                          label="Quarter Range: "
                          id="Quarter Range"
                          fullWidth
                          placeholder=""
                          InputLabelProps={{
                            shrink: true,
                          }}
                          disabled
                          value={qtrRange}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </>
        )}
        <div className="row" style={{ marginTop: 15 }}>
          <div className="unallocated" style={{ width: '100vw' }}>
            <TableGridWithFeatures
              gridHeight={fullScreenView ? '70vh' : viewPortHeight_355}
              columnDefs={TableHead}
              rowData={rows || []}
              gridCall={onGridReady}
              data-testid="onEditingStopped"
              enterMovesDown
              showResetFilter={false}
              defaultCol={{
                wrapHeaderText: true,
                autoHeaderHeight: true,
              }}
              noGlobalSort
              frameworkComponents={{
                TextBoxRender: (cellInfo) => {
                  const name = cellInfo?.value;
                  if (name && name.length > 20) {
                    return (
                      <OverlayTrigger
                        placement="bottom"
                        overlay={<Tooltip id="labeler-tooltip">{name}</Tooltip>}
                      >
                        <div>{name}</div>
                      </OverlayTrigger>
                    );
                  }
                  return <div>{name}</div>;
                },
              }}
              countValue={count}
              hideTotalCount={false}
              exportFile
              reportName="NDC History Report"
              fileName="NDCHistory"
              isScrollOn
              exportAllTpPDF={exportAllTpPDF}
              fullScreenView={fullScreenView}
              handleFullScreenViewClick={changeFullScreenView}
              info={{ firstInfo, secondInfo, thirdInfo, fourthInfo, fifthInfo }}
              onSortChanged={onSortChanged }
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default DisplayNDCHistory;
